








































































import { CatalogFieldConfig } from '@empathybroker/tsclient-play/dist/models/instance/catalog-field-config';

import Vue from 'vue';

import { AlignEnum, CatalogFieldTypeEnum } from '../../enums';

import DataTable from '../crud/data-table.component.vue';
import EditableLabel from '../editable-label.component.vue';
import { UiButton, UiIconButton, UiTextbox } from '../keen-ui';
import EpbSwitch from '../switch.component.vue';

export default {
  name: 'catalog-fields-form',
  props: {
    instance: {
      type: Object,
      required: true
    }
  },
  components: {
    EditableLabel,
    EpbSwitch,
    DataTable,
    UiButton,
    UiTextbox,
    UiIconButton
  },
  computed: {
    actionIconButtonProps: function () {
      return {
        size: 'mini',
        type: 'secondary'
      };
    }
  },
  data: function () {
    const messages = this.$epb.messages.tools.instances.fields.catalog.fields;
    const fieldTypeColumns = Object.values(CatalogFieldTypeEnum).map((fieldType: CatalogFieldTypeEnum) =>
      ({
        id: fieldType,
        text: messages.types[fieldType],
        align: AlignEnum.CENTER
      }));
    return {
      creationField: {},
      editionField: {},
      columns: [
        {
          id: 'id',
          text: messages.id.label
        },
        {
          id: 'prettyName',
          text: messages.prettyName.label
        },
        ...fieldTypeColumns,
        {
          id: 'actions',
          align: AlignEnum.CENTER,
          width: '10rem'
        }
      ],
      messages: messages,
      CatalogFieldTypeEnum
    };
  },
  methods: {
    isFieldSelected(fieldId: string): boolean {
      return fieldId === this.editionField.originalId;
    },
    isFieldIdRepeated(fieldId: string, ignoreSelectedField?: boolean): boolean {
      if (ignoreSelectedField) {
        return this.instance.catalog.fields.some((catalogField: CatalogFieldConfig) =>
          !this.isFieldSelected(catalogField.id) && catalogField.id === fieldId);
      } else {
        return this.instance.catalog.fields.some((catalogField: CatalogFieldConfig) => catalogField.id === fieldId);
      }
    },
    isFieldValid(field: CatalogFieldConfig, ignoreSelectedField?: boolean): boolean {
      return !!field.id && !this.isFieldIdRepeated(field.id, ignoreSelectedField);
    },
    onAddFieldClick: function (): void {
      if (this.isFieldValid(this.creationField)) {
        this.instance.catalog.fields.push(this.creationField);
        this.creationField = {};
      }
    },
    setEditionFieldProperty(field: string, value: string): void {
      Vue.set(this.editionField, field, value);
    },
    isEditIconButtonDisabled(fieldId: String): boolean {
      return (this.isFieldSelected(fieldId) && !this.isFieldValid(this.editionField, true)) ||
        (!this.isFieldSelected(fieldId) && !!this.editionField.originalId);
    },
    onEditClick(field: CatalogFieldConfig): void {
      if (!this.isFieldSelected(field.id)) {
        this.editionField = { ...field, originalId: field.id };
      } else if (this.isFieldValid(this.editionField, true)) {
        const selectedField = this.instance.catalog.fields.find((catalogField: CatalogFieldConfig) =>
          catalogField.id === this.editionField.originalId);
        Object.assign(selectedField, { id: this.editionField.id, prettyName: this.editionField.prettyName });
        this.editionField = {};
      }
    },
    onDeleteClick(field: CatalogFieldConfig): void {
      const catalogFields = this.instance.catalog.fields;
      catalogFields.splice(catalogFields.indexOf(field), 1);
      this.editionField = {};
    }
  }
};
